var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.5 34.375C35.0939 34.375 41.25 28.2189 41.25 20.625C41.25 13.0311 35.0939 6.875 27.5 6.875C19.9061 6.875 13.75 13.0311 13.75 20.625C13.75 28.2189 19.9061 34.375 27.5 34.375Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8125 12.0312H48.125",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9688 6.875V17.1875",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65625 46.4042C8.76937 42.7467 11.8078 39.7096 15.4663 37.598C19.1248 35.4865 23.2746 34.375 27.4987 34.375C31.7228 34.375 35.8726 35.4867 39.531 37.5983C43.1895 39.7099 46.2279 42.747 48.3409 46.4047",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4035 25.3908C39.4844 27.8724 37.8684 30.0359 35.7495 31.6213C33.6307 33.2067 31.0991 34.1467 28.459 34.3282C25.8189 34.5097 23.1825 33.9252 20.8666 32.6447C18.5506 31.3642 16.6537 29.4423 15.4035 27.1099C14.1534 24.7774 13.6033 22.1336 13.8193 19.4961C14.0353 16.8586 15.0082 14.3395 16.6211 12.2415C18.2341 10.1436 20.4185 8.55589 22.9119 7.66926C25.4053 6.78263 28.1016 6.63476 30.677 7.24341",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlus);
export default __webpack_public_path__ + "static/media/UserPlus.ca11300d203128404e5b45086c5aafda.svg";
export { ForwardRef as ReactComponent };